// React
import React, { Component } from "react";

// Elements
import { 
  Alert, 
  Card, 
  CardBody, 
  CardHeader, 
  Col, 
  Container, 
  FormGroup,
  Input, 
  Label, 
  Row, 
  Table 
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Select from "react-select";


// Componets
import { ButtonPattern } from "components/ButtonPattern";
import { LinkPattern } from "components/LinkPattern";
import { Loading } from "components/Loading";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// helpers
import { formatCpfCnpj } from '../../helpers/Functions/index';

// Services
import { searchClienteService } from '../../services/ClienteService';

import { searchGrupoCobrancaWebrenaveService } from '../../services/GrupoCobrancaWebrenaveService';


class FaturamentoWebrenaveList extends Component {
  constructor(props) {
    super(props)
    this.state = {
            
      clientes: [],
      selectClienteID: '',
      selectCliente: '',
      ftr_cpfCnpj: '',
      clientesList: [],
      consultaRealizada: false,
      isLoading: false,
      msgBox: {
        color:  (typeof props.location.msgBox != 'undefined' ? props.location.msgBox.color : 'sucess'),
        display: (typeof props.location.msgBox != 'undefined' ? props.location.msgBox.display : false),
        msg:  (typeof props.location.msgBox != 'undefined' ? props.location.msgBox.msg : [])
      }
    }
  }

  // Faz a consulta do município pelo ID
  searchMunicipioByID = async (municipioID) => {
    const municipio = await searchMunicipioByIDService(municipioID);
    return municipio;
  }

  // Faz a consulta do município pela descricao
  searchClientes = async (ftr_cliente) => {
    const clientes = await searchClienteService({'ftr_nome':ftr_cliente});
    return clientes;
  }

  // Preenche o select 2
  fillSelectCliente = async (clienteID) => {
    const response = await this.getClienteByIDService(clienteID);
    
    if(response.errors.length == 0) {
      const cliente = response.cliente;
      const selectCliente = {
        label: `${cliente.nome}`, 
        value: cliente.id 
      }
      this.setState({selectCliente});
    }
  }
  
  // Faz o filtro da consulta no select 2 do cliente
  handleSelectCliente = (ftr_cliente) => {
    if(ftr_cliente.length > 2) {

      this.searchClientes(ftr_cliente).then(response => {
        const clientes = response.clientes.map(cliente => {
          return {
            label: `${cliente.nome}`, value: cliente.id 
          }
        })
        this.setState({clientes})
      })
    }
  }

  // Altera o estados das variáveis para o select do cliente
  handleChangeCliente = (event) => {
    if(event != null) {
      this.setState({
        selectClienteID: event.value,
        selectCliente: event // Mostra o select pressionado
      });
    } else {
      this.setState({
        selectClienteID: '',
        selectCliente: event
      });
    }
  }
  
  // Atualiza o estado da variável conforme o usuário vai digitando
  handleChange = (event) => {
    const field = event.target.name;

    switch (field) {
      case 'ftr_cpfCnpj':
        this.setState({[field]: formatCpfCnpj(event.target.value)});
        break;
      default:
        this.setState({[field]: event.target.value});
        break;
    }
  }
   
  // Faz o submit no form 
  handleSubmit = async (event) => { 
    this.setState({isLoading: true});

    // variables
      const {
        clientesList,
        ftr_cpfCnpj,
        selectClienteID,
        selectCliente,
      } = this.state;
      let errors = [];
    //---

    const searchParams = {
      cliente_id: selectClienteID,
      'cpf_cnpj': ftr_cpfCnpj.replace(/\D/gim, '')
    }

    const response = await searchGrupoCobrancaWebrenaveService(searchParams);

    // Pega o erro que vem da consulta da API
    if(response.errors.length == 0) {
      this.setState({
        clientesList: response.gruposWebrenave,
        consultaRealizada: true,
        isLoading: false
      });
    } else {
      response.errors.forEach(msg => {
        errors.push(msg.message)
      });
      this.setState({
        msgBox: {color: 'danger', display: true, msg: errors },
        isLoading: false
      }) 
    }
    
    event.preventDefault();
  }
  
  render() {
    // Variáveis
      const {
        clientes, 
        clientesList,
        consultaRealizada, 
        ftr_cpfCnpj,
        isLoading,
        msgBox,
        selectCliente
      } = this.state;
    //---

    // Esconde a mensagem
      const msgBoxDismiss = () => {
        this.setState({msgBox: {color: 'success', display: false, msg: []}})
      }
    //---

    return (
      <React.Fragment>
        <Loading isShow={isLoading} />
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Cliente" breadcrumbItem="Cliente" />
            <Row>
              <Col xl={12}>
                <Alert color={msgBox.color} isOpen={msgBox.display} toggle={msgBoxDismiss} fade={false}>
                  <ul>
                    { msgBox.msg.map( (msg, index) => <li key={index}>{msg}</li>) }
                  </ul>
                </Alert>
                <Card>
                  <CardHeader style={{backgroundColor: "#fff"}}>
                    <LinkPattern 
                      to={`/grupoWebrenave/create`} 
                      className="btn btn-primary" 
                      style={{float: 'right'}}
                      action="cadastra"
                    >
                      Cadastrar
                    </LinkPattern>
                  </CardHeader>
                  <CardBody>
                    <h4 className="card-title">Filtros de clientes</h4>
                    <AvForm className="needs-validation" onSubmit={this.handleSubmit}>
                      <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <div className="mb-3 select2-container">
                            <Label>Cliente</Label>
                            <Select
                              placeholder="Mínimo 3 caracteres para consulta"
                              classNamePrefix="select2-selection"
                              isClearable={true}
                              onInputChange={this.handleSelectCliente}
                              onChange={this.handleChangeCliente}
                              options={clientes}
                              value={selectCliente}
                            />
                          </div>
                        </Col>

                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                          <FormGroup>
                            <Label htmlFor="ftr_cpfCnpj">CPF/CNPJ</Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="ftr_cpfCnpj"
                              name="ftr_cpfCnpj"
                              onChange={this.handleChange}
                              value={ftr_cpfCnpj}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={3}>
                          <ButtonPattern 
                            className="btn btn-primary"
                            type="submit" 
                            style={{marginTop: "15px"}}
                            action="pesquisa"
                          >
                            Pesquisar
                          </ButtonPattern>
                        </Col>
                      </Row>

                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row> 

            <Row style={consultaRealizada ? {display: "block"} : {display: "none"}}>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">Listagem de clientes </h4>
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Nome</th>
                            <th>CPF/CNPJ</th>
                            <th>Parceiro</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (clientesList.length > 0 ?
                              clientesList.map(grupoCobranca => {
                                return (
                                  <tr key={grupoCobranca.id}>
                                    <th scope="row">
                                      <LinkPattern 
                                        to={`/grupoWebrenave/${grupoCobranca.id}/edit`} 
                                        style={{fontSize: "20px"}}
                                        action="atualiza"
                                      >
                                        <i className="bx bx-edit" />
                                      </LinkPattern>
                                    </th>
                                    <td>{grupoCobranca.cliente.nome}</td>
                                    <td>{formatCpfCnpj(grupoCobranca.cliente.cpf_cnpj)}</td>
                                    <td>{grupoCobranca.cliente.parceiro.descricao}</td>
                                    <td>
                                      <span className={`font-size-12 badge rounded-pill ${grupoCobranca.cliente.ativo ? 'bg-success': 'bg-danger'}`}>
                                        {grupoCobranca.cliente.ativo ? 'SIM': 'NÃO'}
                                      </span>
                                      </td>
                                  </tr>
                                )
                              })
                            :
                              <tr style={{textAlign: "center"}}>
                                <td colSpan={4}>Nenhum registro encontrado!</td>
                              </tr>
                            )
                          }
                        </tbody>
                      </Table>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default FaturamentoWebrenaveList;
